'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function address() {
    return {
        id: 'address',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-address',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.address.placeholder'),
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.address.required-error'),
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.minLength(2),
                message: magicCommon.translate('sign-up-step-two.address.min-length-error'),
            },
            {
                name: 'max-length',
                fn: magicFormBuilder.maxLength(100),
                message: magicCommon.translate('sign-up-step-two.address.max-length-error'),
            },
            {
                name: 'not-only-whitespaces',
                fn: magicFormBuilder.notOnlyWhitespaces,
                message: magicCommon.translate('sign-up-step-two.address.not-only-whitespaces-error'),
            },
        ],
        converter: function (formValue) {
            return {
                address1: formValue.address.value,
            };
        },
    };
}

exports.address = address;
